import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export default function ManualInput({ values, onChange, disabled }) {
  const { t } = useTranslation()

  const field = (key, ariaLabel, type = "text", numeric = false) => (
    <div>
      <label htmlFor={`dt-manual-${key}`} className="block text-sm font-medium text-gray-700 mb-1">
        {t(`natura_operations.deposit_transfer.${key}`)}
      </label>
      <input
        id={`dt-manual-${key}`}
        type={type}
        inputMode={numeric || type === "number" ? "numeric" : undefined}
        aria-label={ariaLabel}
        value={values[key] || ""}
        disabled={disabled}
        min={type === "number" ? 1 : undefined}
        onChange={(e) => onChange({ [key]: e.target.value })}
        className="w-full font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
      />
    </div>
  )

  return (
    <div className="space-y-3">
      {field("store_id", "store_id", "text", true)}
      {field("sku", "sku")}
      {field("lot_code", "lot_code")}
      {field("quantity", "quantity", "number")}
      {field("warehouse_location", "warehouse_location")}
    </div>
  )
}

ManualInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

ManualInput.defaultProps = {
  disabled: false,
}
